import styled from 'styled-components';

export const Article = styled.div`
	background: #fff;
	width: 400px;
	border-radius: 6px;
`;

export const Wrapper = styled.div`
	display: flex;
	width: 445px;
	border-right: 1px solid #d8dee6;
`;
